import { Component, OnInit, ViewChild, ViewChildren, ElementRef, AfterViewInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { AngularFireDatabase,AngularFireList } from '@angular/fire/database';
import { GlobalVars } from '../../../providers/globalVars';
import { OrderByPipe } from '../../../pipe/orderbypipe';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { TabsPage } from '../../../tabs/tabs.page';
import { ActionSheetController, Platform, AlertController, ToastController,
IonRouterOutlet, ModalController, NavController, IonContent } from '@ionic/angular';
import { DiscountdetailComponent } from '../../../pages/support/discountdetail/discountdetail.component';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';

import {TranslateService} from '@ngx-translate/core';
import { FirstvisitmodalPage } from '../../support/firstvisitmodal/firstvisitmodal.page';
import { Roulette2Page } from '../../custom/roulette2/roulette2.page';
import * as firebase from 'firebase/app';
import { AuthData } from '../../../providers/auth-data';
//import { AdMob } from "@ionic-native/admob-plus/ngx";
// import { Meta, Title } from '@angular/platform-browser';
import { MetaService } from 'ng2-meta';
import * as geofirex from 'geofirex';
// import { Subscription } from 'rxjs';
// import { DragulaService } from 'ng2-dragula';
// import * as autoScroll from 'dom-autoscroller';

import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss']
})
export class HomePage implements OnInit {
  geo = geofirex.init(firebase);
  favlist: any[] = [];
  //loadedfav: boolean = false;
  categorytemp: any[] = [];
  chlist: any[] = [];
  chrecent: any[] = [];
  loclan: any;
  loadingdone: boolean = false;
  favsub: any;
  loaditemcnt: any = 10;
  //
  currentuid: any;
  mych: boolean = false;
  fav: boolean = false;
  ch: any;
  chname: any;
  chorder: string = 'lastupdate';
  //
  shownow: any[] = [];
  infobanner: any[] = [];
  boardlist: any[] = [];
  boardlistpage: number = 0;
  chcat: any;
  dir: any;
  advlistall: any[] = [];
  advlist: any[] = [];
  advpage: number = 0;
  serviceslt: any;
  servicelist: any[] = [];
  setfield: any[] = [];
  formname: any;


  loadingboard: boolean = true;
  loadingdiscount: boolean = false;
  loadingservice: boolean = false;
  loadingadv: boolean = false;

  Arr = Array;
  datenow: any = new Date().getTime();

  fixedheader: any = false;
  activeheader: any = false;
  //newanytalk:boolean = false;

  scrVal: any;
  lastScrVal: any;
  // @ViewChild('tabsheader') tabsheader: ElementRef;
  // @ViewChild(TabsPage) tabspage: TabsPage;
  @ViewChild(IonContent) content: IonContent;
  // @ViewChild('favchann') favchann;
  @ViewChild('favchann') favchann: ElementRef;
  @ViewChild('totalchannel') totalchannel;

  delayload: boolean = false;
  fakefav: boolean = false;

  typemain: any = '';
  locateAll: boolean = true;

  currentTab: any;

  ltdropdown = false;

  filterCommon: any = 'plus';
  // filterCommon = 'plus' | 'minus' | 'only';

  devWidth = this.platform.width();
  feedskeletons = [0,1,2,3,4,5];
  sliceBoarditems = 6;

  // slide options start
  slideOptsOne = {
    autoplay: false,
    zoom: false,
    slidesPerView: 1, //몇개씩 보여줄지 
    slidesPerGroup: 1, //몇개씩 슬라이드 할지
    slidesPerColumn: 1, // 모바일 버전 slide Column 1
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 320px
      576: {
        slidesPerView: 2,
        slidesPerGroup: 2
        // spaceBetween: 10
      },
      // when window width is >= 480px
      992: {
        slidesPerView: 3,
        slidesPerGroup: 3
        // spaceBetween: 20
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 4
        // spaceBetween: 30
      }
    }
  };
  hotliveOpt = {
    autoplay: false,
    zoom: false,
    slidesPerView: 1, //몇개씩 보여줄지 
    slidesPerGroup: 1, //몇개씩 슬라이드 할지
    slidesPerColumn: 1, // 모바일 버전 slide Column 1
    pagination: {
      el: '.hotlive_pagination',
      type: 'fraction'
      // clickable: true,
    },
    breakpoints: {
      // when window width is >= 320px
      576: {
        slidesPerView: 2,
        slidesPerGroup: 2
        // spaceBetween: 10
      },
      // when window width is >= 480px
      992: {
        slidesPerView: 3,
        slidesPerGroup: 3
        // spaceBetween: 20
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 4
        // spaceBetween: 30
      }
    }
  };
  // hotlivePagination = 1;
  adbannerOpt = {
    autoplay:{delay:6000}, 
    speed:500, 
    // loop: this.advlist.length > 1 ? true : false, 
    loop: false,
    slidesPerView: 1,//,
    // slidesPerView: this.advlist.length >= 2 ? 2 : 1,
    slidesPerGroup: 1,
    // centeredSlides: true,
    breakpoints: {
      576: {
        slidesPerView: this.advlist.length >= 2 ? 2 : 1
        // spaceBetween: 10
      },
      992: {
        slidesPerView: this.advlist.length >= 3 ? 3 : this.advlist.length >= 2 ? 2 : 1
        // spaceBetween: 20
      },
      1200: {
        slidesPerView: this.advlist.length >= 4 ? 4 : this.advlist.length >= 3 ? 3 : this.advlist.length >= 2 ? 2 : 1
        // slidesPerView: this.advlist.length >= 2 ? 2 : 1
        // spaceBetween: 30
      }
    }
  }
  slideOptsTwo = {
    autoplay: false,
    zoom: false,
    slidesPerView: 1,
    slidesPerColumn: 2, // 태블릿 모드에서는 column만 2줄로 하고 아이템 2행 css로 
    slidesPerGroup: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  };
  slideOpt_centered = {
    slidesPerView: 'auto',
    spaceBetween: 20,
    zoom: false,
    // centeredSlides: true,
    autoplay: {
      delay: 3000,
    },
    loop: false,
    pagination: false,
  }
  // slide options end
  //advurl:any;

  channguide = false; // 채널 추가시 나오는 안내 팝업용
  editable:boolean = false; // favitem drag모드용
  favtoast:any; // favitem 용 toast

  @ViewChild('citybox') citybox;
  @ViewChild('cityboxInner') cityboxInner;

  titeditmode_total = false;

  adtagshow:boolean = false;

  ongoingevent:any = ""; //진행할 이벤트 
  isongoing:boolean = false; //진행할 이벤트를 노출할지

  orgTitle = '';
  orgDescription = '';

  temploc:any;

  // hotlivelist:any;
  chann_devider = 6;
  advslide;
  showtype = 'recent';
  constructor(public platform: Platform, public afDB: AngularFireDatabase, public gv: GlobalVars, public router: Router, private afAuth: AngularFireAuth,
    private outlet:IonRouterOutlet,private toastCtrl: ToastController, public alertCtrl: AlertController, public modalCtrl: ModalController,
    public translate: TranslateService, private authData:AuthData, private orderby: OrderByPipe, public storage: Storage, public actionSheetController: ActionSheetController,
    // private mtitle: Title, private meta: Meta
    private changeDetectorRef:ChangeDetectorRef, private ngzone:NgZone,
    public metaService: MetaService,
    public navCtrl: NavController, private fs:AngularFirestore
    ) {
    }

  chkpage(){
      this.gv.recentlistpage = this.gv.recentlist? Math.ceil(this.gv.recentlist.length / 6):1
      this.gv.boardlistpage = this.gv.boardlist? Math.ceil(this.gv.boardlist.length / 6):1
  }

  ngOnInit() {
    this.gv.getRegion(); //열려있는 지역(도시)값 불러옴
    // setTimeout(() => {
    //   let cd = 9999999999999999999;
    //   setInterval(()=>{
    //     let count = 0;
    //     this.fs.collection('post', ref=>ref.orderBy('createdDate', 'desc').startAt(cd).limit(300)).get().subscribe(s=>{
    //       count = 0;
    //       s.forEach((data)=>{
    //         count++;
    //         data.ref.collection('comment').get().then(rst=>{
    //           let dt = data.data();
    //           if(rst.docs.length)
    //             data.ref.update({read:dt.read, replycount:rst.docs.length});
    //           else
    //             data.ref.update({read:dt.read})
    //           cd = dt.createdDate;
    //           if(count > 299)
    //             console.log(dt.title + (dt.replycount?'('+ dt.replycount +')':'') + ' - 댓글수:' + rst.docs.length + ':' + cd)
    //         })
    //       })
    //     })
    //   },4000)  
    // }, 3000);
    // this.orgTitle = this.metaService.router.config[1].data.meta.title;
    // this.orgDescription = this.metaService.router.config[1].data.meta.description;
    //this.gv.restoreOnStorage('savedaccloc').then(l=>{if(l){this.gv.loc = l}});
    
    
    // 리스토어.. 일단 임시정지
    
    this.gv.restoreOnStorage('ufavlist').then(uf => { if (uf) { 
      this.gv.ufavlist = uf; 
      this.gv.getHotLive(this.gv.ufavlist);
    } });
    this.gv.restoreOnStorage('listdata').then(p => { if (p) { this.gv.boardlist = p; this.gv.boardlistpage = Math.ceil(this.gv.boardlist.length / 6); } else{this.gv.loadingboard = true;} });
    this.gv.restoreOnStorage('advlist').then(a => { if (a) { 
      this.advlist = a;
      this.adbannerOpt.slidesPerView = 1;
      this.adbannerOpt.breakpoints = {
      576: {
        slidesPerView: this.advlist.length >= 3 ? 2 : 1
        // spaceBetween: 10
      },
      992: {
        slidesPerView: this.advlist.length >= 3 ? 3 : this.advlist.length >= 2 ? 2 : 1
        // spaceBetween: 20
      },
      1200: {
        slidesPerView: this.advlist.length >= 4 ? 4 : this.advlist.length >= 3 ? 3 : this.advlist.length >= 2 ? 2 : 1
        // slidesPerView: this.advlist.length >= 2 ? 2 : 1
        // spaceBetween: 30
      }
    }
    } });
    this.gv.restoreOnStorage('chlist').then(c => { if (c) { this.chlist = c; } });
    if (this.gv.loc) {
      this.temploc = this.gv.loc;
      this.getadv();
    }
    

    // responsive platform resize
    this.getSkeletons();
    this.platform.resize.subscribe(async () => {
      this.devWidth = this.platform.width();
      this.getSkeletons();
    });

    /* 이벤트 추첨결과 확인 디비
    let prize = [];
    let count = 0;
    this.afDB.database.ref('/userData').once('value').then(rst=>{
      
      rst.forEach(r=>{
        let pitem = r.val().pointitem
        if(pitem)
        {
          this.afDB.database.ref('/userProfile/' + r.key + '/nickname').once('value').then(a=>{
            Object.keys(pitem).forEach(item=>{
              if(pitem[item].pitemid == '-LviY4_1gtO4xsp4Na1_' && pitem[item].createdDate > 1581636308439)
              {  
                count++;
                prize.push({status:(pitem[item].used?'**사용됨**':'보유중'),name:a.val(),date:new Date(pitem[item].createdDate).toLocaleString(),key:r.key})
              }
            })
          })
        }
      })
    })
    setTimeout(_=>{
    prize = this.orderby.transform(this.orderby.transform(prize,'date','asc'), 'status', 'asc')
    console.log(count);
    prize.forEach(p=>{
      console.log(p.name + '] ' + p.status + ' ' + p.date)
    })
      
    },8000)*/

    // this.dragulaService.createGroup('favchann', {});
    // document.getElementById('favthumb').draggable = false;
    // document.getElementById('favthumb').ondragstart = function() { return false; };
    // sample ca-app-pub-3940256099942544/2934735716 real ca-app-pub-8852191677614185/1186869645
    //if(this.platform.is('cordova')) this.admob.banner.show({ id: "test" }).then(_=>{console.log(_)}).catch(e=>{console.log(e)});
    /*
    let idval = this.platform.is('ios')?'ca-app-pub-8167936939933361~6444163234':'ca-app-pub-8167936939933361~4009571589';
    console.log(idval);
    if(this.platform.is('cordova'))
      this.admob.banner.show(//{id:'ca-app-pub-3940256099942544/6300978111'}
        {id:{android:'ca-app-pub-8167936939933361/8117650631',ios:'ca-app-pub-8167936939933361/2865323951'}}
      ).then(_=>{
        console.log('admob!!!!!!!!!!!!!!')
        console.log(_);
      }).catch(e=>{console.log('error!!!!admob!!!!'); console.log(e)});
    else
      console.log('not cordova!!!!')
    */
    this.dir = '/list';
    /*
    this.gv.getLocLan().then(loclan => {
      this.loclan = loclan;
      this.chcat = loclan;
      this.dir = this.gv.getListDir(this.chcat);

      if(!this.gv.loc) { // 임시처리, 비회원이 지역값 없을때 최초 1회만 노출 되어야 합니다.
        this.firstvisitModal();
      }
      this.getdata();
    })*/
    /*
    this.afDB.database.ref('/category').orderByChild('loc').equalTo('브리즈번').once('value').then(rst=>{
      rst.forEach(r=>{
        console.log(r.key + ':' + r.val().name)
        if(r.key)
          this.afDB.database.ref('/category/' + r.key).update({loc:'brisbane'})
      })
    })*/
    this.getdata();
    // this.afAuth.authState.subscribe(_=>{
    //   console.log('어스어스')
    //   this.authData.gethomedata();
    // })
    // this.getHotLive(this.gv.ufavlist);
  }

  getSkeletons(){
    if( this.devWidth >= 1200 ) {
      this.feedskeletons = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];
      this.chann_devider = 12;
    } else if( this.devWidth >= 992 ) {
      this.feedskeletons = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17];
      this.chann_devider = 9;
    } else if( this.devWidth >= 576 ){
      this.feedskeletons = [0,1,2,3,4,5,6,7,8,9,10,11];
      this.chann_devider = 8;
    } else {
      this.feedskeletons = [0,1,2,3,4,5];
      this.chann_devider = 6;
    }
  }

  ionViewDidEnter() {
    this.gv.selectedcontent = this.content;
    if (this.temploc != this.gv.loc) {
      this.temploc = this.gv.loc;
      this.getadv();
    }
    // this.metaService.setTitle(this.orgTitle);
    // this.metaService.setTag('og:title', this.orgTitle);
    // this.metaService.setTag('og:description', this.orgDescription);
    this.metaService.setTitle('채널 - 호주 우리동네 정보를 한눈에!');
    this.metaService.setTag('og:title', '채널 - 호주 우리동네 정보를 한눈에!');
    this.metaService.setTag('og:description', '채널은 호주 모든 정보를 한눈에 알기쉽게 볼수 있는 커뮤니티 앱입니다. 호주의 맛집, 장소, 관광, 쇼핑, 취미, 쉐어, 구인 등 다양한 주제로 여러분에게 맞춤형 정보를 제공해드립니다.');
    //this.metaService.setTag('og:image', '/assets/img/chsocial.jpeg');

    if(this.gv.chreloadrequest) {
      // if(this.list) this.list.unsubscribe();
      this.gv.restoreOnStorage('listdata').then(p => { 
        if (p) { 
          this.gv.boardlist = p;
          this.gv.boardlistpage = Math.ceil(this.gv.boardlist.length / 6);
        } 
      });
      this.gv.chreloadrequest = false;
    }

  }
get Math() {
  return Math;
}
  // ngOnDestroy() {
  ionViewWillLeave() {
    this.gv.selectedcontent = null;
    // this.subs.unsubscribe();
    this.clearScrolling();
  }

  getdata() {
    this.getadv();
    let categorytemp = [];
    this.afDB.database.ref('/category')
      .once('value').then(item => {
        this.chrecent = [];
        item.forEach(ch => {
          let data = ch.val();
          var lastupdate;
          let recentcount = 0;
          if (data.recent) {
            lastupdate = data.recent[Object.keys(data.recent)[Object.keys(data.recent).length - 1]].createdDate;
            Object.keys(data.recent).forEach(r => {
              if ((this.datenow - data.recent[r].createdDate) / (1000 * 60 * 60 * 24) < 2)
                recentcount++;
            })
          }
          else
            lastupdate = 0;
          var point;
          if (data.publiccommunity)
            point = data.point;
          else
            point = data.point - 1000;

          let optionsArr:any = {};
          if(data.category && (data.category).length) {
            for(let i=0; i < (data.category).length; i++){
              if(data.category[i].anonymouscmt){optionsArr.isAnonymouscmt = true;}
              if(data.category[i].privatecmt){optionsArr.isPrivatecmt = true;}
            }
          }

          categorytemp.push({
            key: ch.key,
            typemain: data.typemain,
            imagethumb: data.imagethumb,
            name: data.name,
            replycount: data.replycount,
            read: data.read,
            createdDate: data.createdDate,
            type: data.type,
            userId: data.userId,
            chinfo: data.chinfo,
            point: point,
            loc: data.loc,
            description: data.description,
            publiccommunity: data.publiccommunity,
            lastupdate: lastupdate, // new:newupdate,
            recentpost: recentcount,
            optionsArr: optionsArr
          });

        })
        this.chlist = categorytemp;
      }).then(_ => {
        this.loadingdone = true;
        this.gv.storeOnStorage('chlist', this.chlist);
        if (this.gv.needfillfav) { // 리, 비회원이 지역값 없을때 최초 1회만 노출 되어야 합니다.
          //console.log('첫방문')
          this.firstvisitModal();
        }
        else {
          this.storage.get('savedaccloc').then(rst => {
            if (!rst && !this.gv.loc)
              this.firstvisitModal();
          })
        }
      })

    this.Arr = Array;
  }

  trackByFnList(index, item) {
    if(!item.data)
      return null;
    else
      return (item.data.imagethumb, item.data.title, item.data.read, item.data.replycount, item.data.communityname, item.data.type,
      item.createdDate);
  }
  trackByFnList2(index, item) {
    if(!item.data)
      return null;
    else
      return (item.data.imagethumb, item.data.title, item.data.read, item.data.replycount, item.data.communityname, item.data.type,
      item.createdDate);
  }
  trackByFnFav(index, fav) {
    return (fav.chid, fav.loc, fav.isChecked, fav.customtitle, fav.title, fav.img, fav.isMine);
  }

  trackByFnAdv(index, aditem) {
    return (aditem.img, aditem.event, aditem.adtext);
  }

  trackByFnCat(index, category) {
    return (category.publiccommunity, category.key, category.imagethumb, category.name,
      category.recentpost, category.description, category.loc, category.typemain,
      category.createdDate, category.point, category.chinfo);
  }

  calladvcount: any = 0;
  getadv() {
    //console.log(this.gv.loc)
    //console.log('광고셋업!')
    if (this.gv.loc) {
      let tempadv = [];
      let now = new Date();
      let targetstart = 'home@' +
        now.getFullYear() +
        (((now.getMonth() + 1) < 10) ? '0' + (now.getMonth() + 1) : '' + now.getMonth()) + '@';
      this.afDB.database.ref('/event/ongoing').once('value').then(event => {
        if (event.val()) {
          this.ongoingevent = event.val().title;
          this.isongoing = event.val().public;
        }
        this.afDB.database.ref('/adv/banner').orderByChild('target').startAt(targetstart).once('value').then(items => {
          if (this.ongoingevent == 'NewYearRoulette2' && (this.isongoing || (!this.isongoing && this.gv.manager))) {
            tempadv.push({ img: 'assets/temp/newyearevent/bannerrl.jpeg', event: true, orderrate: 99999 })
          }
          items.forEach(item => {
            if (item.val().show && !item.val().hideatnewver) {
              let itemtarget = item.val().target.split('@');
              if (itemtarget[1] == targetstart.split('@')[1] && (itemtarget[2] == this.gv.loc || itemtarget[2] == 'all-aus')) {
                let orderrate = Math.floor(Math.random() * item.val().prioritypoint);
                tempadv.push({ img: item.val().img, url: item.val().route, orderrate: orderrate });
              }
            }
          })

          if (tempadv.length > 0) {
            tempadv = this.orderby.transform(tempadv, 'orderrate', 'desc').slice(0, 5);
          }
          if (tempadv.length < 4) {
            tempadv.push({ url: '/pitemdetail/-LrRdv_EBNt47INniaxj', orderrate: 0, adtext: '이곳에 광고하기', aditem: true });
          }
          this.advlist = tempadv;
          this.gv.storeOnStorage('advlist', this.advlist);
          
          this.adbannerOpt.slidesPerView = 1;
          // this.adbannerOpt.slidesPerView = this.advlist.length >= 2 ? 2 : 1;
          this.adbannerOpt.breakpoints = {
            576: {
              slidesPerView: this.advlist.length >= 2 ? 2 : 1
              // spaceBetween: 10
            },
            992: {
              slidesPerView: this.advlist.length >= 3 ? 3 : this.advlist.length >= 2 ? 2 : 1
              // spaceBetween: 20
            },
            1200: {
              slidesPerView: this.advlist.length >= 4 ? 4 : this.advlist.length >= 3 ? 3 : this.advlist.length >= 2 ? 2 : 1
              // slidesPerView: this.advlist.length >= 2 ? 2 : 1
              // spaceBetween: 30
            }
          }

        });
      });

      this.calladvcount = 0;
    }
    else {
      if (this.calladvcount < 5)
        setTimeout(_ => { this.calladvcount++; this.getadv() }, 2000)
    }
  }


  doInfinite(infiniteScroll) {
    this.loaditemcnt = this.loaditemcnt + 10;
    infiniteScroll.target.complete();
  }

  ionViewWillEnter() {
    //포스팅 최신글 체크해야함
    if (this.gv.visitedch && this.gv.ufavlist && this.gv.ufavlist.length) {
      this.gv.chkchannelvisit();
    }
    //this.chkdiscount();
    //this.chkadv();

    /*
        if( this.gv.uid == 'fKguqzXQrlRMWvzO3UocaBBr8vs1') {
          console.log(this.safeareatop.nativeElement.style.paddingTop);
          this.presentToast('this.safeareatop.nativeElement.style.paddingTop = ' + this.safeareatop.nativeElement.style.paddingTop);
        }*/
  }



  /*
  jumpbanner(slide) {
    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1)) + '-' + (today.getDate() > 9 ? today.getDate() : '0' + today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.gv.uid ? this.gv.uid : 'unregister') + '/event/' + todaystr + '/mbclick').transaction(view => {
      return (view || 0) + 1;
    })
    slide.getActiveIndex().then(index => {
      if (index == 0)
        index = this.infobanner.length;
      else if (index > this.infobanner.length)
        index = 1;
      this.router.navigate([this.infobanner[index - 1].linkurl]);
    })
  }*/


  jumpadv(slide, i) {
    // slide.getSwiper().then(slides=>{
    //   console.log(slides);
    //   console.log(slides.params.loop + ' / ' + slides.params.slidesPerView)
    // });

    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1)) + '-' + (today.getDate() > 9 ? today.getDate() : '0' + today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.gv.uid ? this.gv.uid : 'unregister') + '/event/' + todaystr + '/adclick').transaction(view => {
      return (view || 0) + 1;
    })

    /*
    slide.getActiveIndex().then(index => {
      if (index == 0) index = this.advlist.length;
      else if (index > this.advlist.length) index = 1;
      if (this.advlist[index - 1].event)
        this.eventModal();
      else {
        if (this.advlist[index - 1].aditem)
          this.gv.aditem = { loc: this.gv.loc };
        this.navCtrl.navigateForward([this.advlist[index - 1].url]);
      }
    })
    */
    if( i == 0 && this.advlist[i].event) {
      this.eventModal();
    } else {
      if(this.advlist[i].aditem)
        this.gv.aditem = {loc:this.gv.loc};
      this.navCtrl.navigateForward([this.advlist[i].url]);
    }
  }

  /*
  chkadv() {
    this.advpage = 0;
    this.advlist = [];
    this.advlistall.forEach(item => {
      if (item.show == 'all' && (new Date().getTime() > new Date(item.startdate).getTime() &&
          new Date().getTime() < new Date(item.enddate).getTime())) {
        item.orderrate = Math.floor(Math.random() * item.advorder); // 
        this.advlist.push(item);
      }
    });
    this.loadingadv = true;
  }
  
  chkdiscount() {
    if (this.discountinfo) {
      this.discountlist = [];
      this.discountinfo.forEach(discount => {
        if (discount.ptype == 'zday') {
          if (new Date().getTime() >= new Date(discount.startdate).getTime() - 1000 * 60 * 60 * 24 && new Date().getTime() < new Date(discount.enddate).getTime() + 1000 * 60 * 60 * 24) {
            discount.startdiff = Math.ceil((new Date().getTime() - new Date(discount.startdate).getTime() - (1000 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24));
            discount.enddiff = Math.ceil((new Date(discount.enddate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
            discount.order = discount.discountorder ? discount.enddiff - discount.discountorder : discount.enddiff;

            this.discountlist.push(discount);
          }
        } else if (discount.ptype == 'weekly') {
          var today = new Date().getDay();
          var chksameday = false;
          discount.day.forEach(day => {
            if (day == today)
              chksameday = true;
          });
          discount.order = discount.discountorder ? 7 - discount.discountorder : 7;
          if (chksameday)
            this.discountlist.push(discount)
        } else if (discount.ptype == 'time') {
          var temphour = parseInt(discount.starttime.split(':')[0]) - 3;
          var hourstring = "";
          if (temphour < 0)
            hourstring = "00";
          else if (temphour < 10)
            hourstring = "0" + temphour.toString();
          else
            hourstring = temphour.toString();
          var adjstarttime = hourstring + ":" + discount.starttime.split(':')[1];

          var timenow = new Date().getHours() + ":" + new Date().getMinutes();
          discount.order = discount.discountorder ? 15 - discount.discountorder : 15;
          //if(timenow > adjstarttime && timenow < discount.endtime)
          {
            this.discountlist.push(discount)
          }
        }
      })
      
      //console.log(this.discountlist);
      this.discountlist = this.discountlist.map(item => {
        this.afDB.database.ref(this.gv.getListDir(item.loclancode) + '/' + item.id).once('value').then(
          rst => item.data = rst.val()
        )
        return item;
      })
      this.loadingdiscount = true;
    }
  }
  
  goservice(link) {
    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1)) + '-' + (today.getDate() > 9 ? today.getDate() : '0' + today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.uid ? this.uid : 'unregister') + '/event/' + todaystr + '/service').transaction(view => {
      return (view || 0) + 1;
    })
    this.router.navigate([link]);
  }
    async discountdetail(list, index) {
    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1)) + '-' + (today.getDate() > 9 ? today.getDate() : '0' + today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.uid ? this.uid : 'unregister') + '/event/' + todaystr + '/event').transaction(view => {
      return (view || 0) + 1;
    })
    const modal = await this.modalCtrl.create({
      component: DiscountdetailComponent,
      //cssClass: 'ph-custom-modal',
      cssClass: 'eventPopup',
      backdropDismiss: true,
      componentProps: < null > {
        list: list,
        index: index
      }
    });
    return await modal.present();
  }
  */

  showrecent() {
    this.gv.param['recentdata'] = this.boardlist;
  }



  async presentToast(message: string) {
    let toast = await this.toastCtrl.create({
      message: message,
      position: 'bottom',
      duration: 2200
    });
    toast.present();
  }







  /*
  ngAfterViewInit() {
    // console.log(this.tabspage.nativeElement);
    // console.log(this.tabspage.getheader());
    // console.log(this.tabspage);
    // console.log(this.tabspage.getheader());
  }
   */

  /*

  logScrollStart(){
    console.log("logScrollStart : When Scroll Starts");
  }
 
  logScrolling(){
    console.log("logScrolling : When Scrolling");
  }
 
  logScrollEnd(){
    console.log("logScrollEnd : When Scroll Ends");
  }
  
  // @ViewChild('scrIp') scrIp: ElementRef;
  logScrolling(event) {
    this.scrVal = event.detail.scrollTop;
    // let scrIp = this.scrIp;
    // console.log(document.getElementById('tempinput'));
    (<HTMLInputElement>document.getElementById('tempinput')).value = this.scrVal;
    if( this.lastScrVal > this.scrVal ) {
      // console.log('up');
      (<HTMLInputElement>document.getElementById('scrdirinput')).value = 'up';
    } else if ( this.lastScrVal < this.scrVal) {
      // console.log('down');
      (<HTMLInputElement>document.getElementById('scrdirinput')).value = 'down';
    } else {
      // console.log('lastScrVal = '+this.lastScrVal+' // this.scrVal = '+this.scrVal);
    }
  }*/

  // logScrolling(event) {
  //   console.log(event.detail.scrollTop);
  // }

  sltcity(city) {
    if (this.gv.uid) {
      this.afDB.database.ref('/userProfile/' + this.gv.uid + '/loc').set(city);
    }
    this.gv.setlocinlocal(city)
    setTimeout(_ => {
      this.gv.loc = city; this.getadv()
    }, 500);
    // setTimeout(_=> {
    //   this.gotochannlist(0, 705);
    // }, 300);
    // this.gotochannlist(0, 723);
    this.gotochannlist(0, this.totalchannel.nativeElement.offsetTop - 28);

    this.cityboxOff();
    //this.refreshdata()
  }
  gotochannlist(x, y) {
    this.content.scrollToPoint(x, y, 500);
  }

  cityboxToggle() {
    if (this.ltdropdown == false) {
      this.cityboxOn();
    } else {
      this.cityboxOff();
    }
  }
  cityboxOn() {
    this.citybox.nativeElement.style.display = 'block';
    this.cityboxInner.nativeElement.scrollLeft = 0;
    setTimeout(_ => {
      this.ltdropdown = true;
    }, 50);
  }
  cityboxOff() {
    this.ltdropdown = false;
    setTimeout(_ => {
      this.citybox.nativeElement.style.display = 'none';
      this.ltdropdown = false;
    }, 300);
  }



  favclick(item) {

    this.ch = item.key;
    this.chname = item.name;
    this.currentuid = this.gv.uid;
    if (this.currentuid) {
      this.afDB.database.ref('/userData/' + this.currentuid + '/favlist').once('value').then(fav => {
        let exist = '';
        //let isChecked;
        if (fav.val()) {
          let favlength = 0;
          fav.forEach(favitem => {
            favlength = favlength + 1;
            if (favitem.val().chid == item.key) {
              exist = favitem.key;
              //isChecked = favitem.val().isChecked;
            }
          })

          if (exist) {

            this.afDB.database.ref('/userData/' + this.currentuid + '/favlist/' + exist).remove().then(_ => {
              this.translate.get('Delete from Favourites Channel').subscribe(res => {
                this.presentToast(res);
              })
            })

          } else {

            this.activeheader = true;
            setTimeout(_ => {
              this.favchann.nativeElement.scrollTo(favlength * 85, 0, 1000)
              //.then(_=>{console.log('성공');console.log(_)}).catch(_=>{console.log('에러');console.log(_)});
              this.delayload = true;
              this.afDB.database.ref('/userData/' + this.currentuid + '/favlist').push({
                chid: this.ch,
                alarm: true,
                loc: item.loc,
                isChecked: true
              }).then(_ => {
                this.translate.get('Added to Favourites Channel').subscribe(res => {
                  this.presentToast(res);
                })
                setTimeout(_ => {
                  this.activeheader = false;
                }, 3000);
              });
              // this.favchann.nativeElement.scrollTo(favlength * 85, 0, 1000);
              // setTimeout(_=>{
              //   this.delayload = true;
              //   this.afDB.database.ref('/userData/' + this.currentuid + '/favlist').push({
              //     chid: this.ch,
              //     alarm: true,
              //     title: this.chname
              //   }).then(_ => {
              //     this.presentToast('즐겨찾기 채널에 추가되었습니다.');
              //   });
              // }, 1000);
            }, 500);
          }
        } else {
          let data = [];
          data.push({
            chid: this.ch,
            alarm: true,
            loc: item.loc,
            isChecked: true,
            title: this.chname
          });
          /*this.afDB.database.ref('/app/defaulttab/' + this.loclan).once('value').then(dffav => {
            dffav.forEach(fav => {
              if (!fav.val().default)
                data.push({
                  title: fav.val().name,
                  isChecked: true,
                  chid: fav.val().val.substr(8).replace('/t', '')
                });
            })*/

          this.afDB.database.ref('/userData/' + this.currentuid + '/favlist').set(data)
            .then(_ => {
              this.translate.get('Added from Favourites Channel').subscribe(res => {
                this.presentToast(res);
              })
            })
          this.fav = true;
          //})
        }
      })
    } else {
      this.translate.get('Please log in to proceed').subscribe(res => {
        this.presentToast(res);
      })
    }
  }



  setTypemain(item, category) {
    // console.log(this.afDB.database.ref('/category/'));
    // console.log(this.afDB.database.ref('/category/' + item.key ));
    switch (category) {
      case 'news':
        item.typemain = '소식';
        // this.afDB.database.ref('/category/' + item.key + "/typemain" ).set('소식');
        this.afDB.database.ref('/category/' + item.key).update({
          typemain: '소식'
        });
        break;
      case 'store':
        item.typemain = '업체';
        this.afDB.database.ref('/category/' + item.key).update({
          typemain: '업체'
        });
        break;
      case 'community':
        item.typemain = '친목';
        this.afDB.database.ref('/category/' + item.key).update({
          typemain: '친목'
        });
        break;
      case 'living':
        item.typemain = '생활';
        this.afDB.database.ref('/category/' + item.key).update({
          typemain: '생활'
        });
        break;
      case 'etc':
        item.typemain = '기타';
        this.afDB.database.ref('/category/' + item.key).update({
          typemain: '기타'
        });
        break;
      default:
    }
  }


  setLocate(item, locate) {
    switch (locate) {
      case 'all':
        // item.loc = '공통';
        // this.afDB.database.ref('/category/' + item.key ).update({loc : '공통'});
        this.afDB.database.ref('/category/' + item.key + "/loc").set('all-aus');
        break;
      case 'cairns':
        // item.loc = '케언즈';
        this.afDB.database.ref('/category/' + item.key).update({
          loc: 'cairns'
        });
        break;
      case 'brisbane':
        // item.loc = '브리즈번';
        this.afDB.database.ref('/category/' + item.key).update({
          loc: 'brisbane'
        });
        break;
      default:
    }
  }


  filterAlert(filterCommon) {
    // if (this.filterCommon == 'plus')
    //   this.presentToast('선택한 지역 + 공통 지역 채널 표시');
    // else if (this.filterCommon == 'minus')
    //   this.presentToast('선택한 지역 채널만 표시');
    // else if (this.filterCommon == 'only')
    //   this.presentToast('공통 지역 채널만 표시');
    if (filterCommon == 'plus')
      this.translate.get('Show common Channels and local Channels').subscribe(res => {
        this.presentToast(res);
      })
    else if (filterCommon == 'minus')
      this.translate.get('Show Channels from chosen area only').subscribe(res => {
        this.presentToast(res);
      })
  }


  async createchannAlert() {
    let chopen, chopenmsg, cancel, create;
    this.translate.get('Do you wish to open a new Channel?').subscribe(res => { chopen = res });
    this.translate.get('Make your own Channel and share information with other users!').subscribe(res => { chopenmsg = res });
    this.translate.get('Cancel').subscribe(res => { cancel = res });
    this.translate.get('Create').subscribe(res => { create = res });

    const alert = await this.alertCtrl.create({
      cssClass: 'createChann',
      header: chopen,
      // subHeader: 'Subtitle',
      message: chopenmsg,
      buttons: [{
        text: cancel,
        role: 'cancel'
      }, {
        text: create,
        role: 'create',
        handler: () => {
          // this.router.navigate(['/tabs/home/chadd']);
          this.navCtrl.navigateForward('/tabs/home/chadd');
        }
      }]
    });

    await alert.present();
  }

  createChann() {
    this.createchannAlert();
  }

  async eventModal() {
    const modal = await this.modalCtrl.create({
      component: Roulette2Page,
      cssClass: 'modalfull',
      componentProps: <null>{}
    });
    return await modal.present();
  }

  async firstvisitModal() {
    const modal = await this.modalCtrl.create({
      component: FirstvisitmodalPage,
      cssClass: 'ph-custom-modal',
      backdropDismiss: false,
      componentProps: <null>{ p: this }
      // componentProps: < null > {
      //   list: list,
      //   index: index
      // }
    });
    modal.onDidDismiss().then(_=>{
     this.refreshdata();
    })
    return await modal.present();
  }

  visitcheck(lastpostdate) {
    //console.log('하이')
    return true;
  }

  doRefresh(refresh) {
    if(!this.gv.loadingboard)
      this.refreshdata(refresh);
    else
      setTimeout(_=>{refresh.target.complete()},150)
  }
  refreshdata(refresh?) {
    this.gv.loadingboard = true;
    this.authData.gethomedata();
    if(refresh) setTimeout(_=>{refresh.target.complete()},1500);
    // if (this.gv.uid && !this.gv.needfillfav) {
    //   firebase.database().ref('/userData/' + this.gv.uid + '/favlist').once('value').then(fav => {
    //     let temp = [];
    //     let templist = [];
    //     let boardtemp = [];
    //     let boardlisttemp = [];
    //     let count = 0;
    //     // if (refresh) setTimeout(_ => { refresh.target.complete() }, 150);
    //     // setTimeout(_ => {
    //       if (fav.val()) {
    //         let favindex = 0;
    //         Object.keys(fav.val()).forEach(fitem => {
    //           let f = fav.val()[fitem];
    //           f.favindex = favindex;
    //           favindex++;
    //           firebase.database().ref('/category/' + f.chid).once('value').then(chval => {
    //             let favdata = chval.val();
    //             if(!favdata)
    //               temp.push({chid:f.chid,alarm:false,title:'삭제된채널',customtitle:f.customtitle})
    //             else
    //               {
    //               temp.push({
    //               chid: f.chid,
    //               alarm: f.alarm,
    //               favindex: f.favindex,
    //               loc: f.loc,
    //               isChecked: f.isChecked,
    //               customtitle: f.customtitle,
    //               title: favdata.name,
    //               img: favdata.imagethumb&&favdata.imagethumb[0]?favdata.imagethumb[0].url:null,
    //               isMine: favdata.userId == this.gv.uid,
    //               lastposting: favdata.recent ? favdata.recent : ''
    //             });
    //             if (favdata.recent)
    //               Object.keys(favdata.recent).forEach(rkey => {
    //                 templist.push({ $key: favdata.recent[rkey].itemid, rcreatedDate: favdata.recent[rkey].createdDate })
    //               })
    //               }

    //             count++;
    //             if (count == Object.keys(fav.val()).length) {
    //               boardtemp = this.orderby.transform(templist, 'rcreatedDate', 'desc').slice(0, 36);
    //               let tempcount = 0;
    //               this.gv.loadingboard = true;
    //               let boardlisttemp = [];
    //               let recentlist = this.gv.getrecent();
    //               let _item:any;

    //               boardtemp.map(data => {
    //                 _item = {};
    //                 this.fs.collection('post').doc(data.$key).get().subscribe(rst=>{
    //                 //firebase.database().ref('/list/' + data.$key).once('value').then(rst => {
    //                   tempcount++;
    //                   if (rst.data()) {
    //                     _item = { $key: data.$key, rcreatedDate: data.rcreatedDate, data: rst.data(), haveread: false };
    //                     recentlist.forEach(recent=>{
    //                       if( recent.itemid == rst.id ) {
    //                         _item.haveread = true;
    //                       }
    //                     });
    //                     // boardlisttemp.push({ $key: data.$key, rcreatedDate: data.rcreatedDate, data: rst.val(), haveread: true });
    //                     boardlisttemp.push(_item);
    //                     if (tempcount == boardtemp.length) {
    //                     this.gv.boardlist = this.orderby.transform(boardlisttemp, 'rcreatedDate', 'desc').slice(0, 30)
    //                     this.gv.storeOnStorage('listdata', this.gv.boardlist);
    //                     this.gv.boardlistpage = Math.ceil(this.gv.boardlist.length / 6)
    //                     this.gv.loadingboard = false;

    //                     this.gv.ufavlist = this.orderby.transform(temp, 'favindex');
    //                     this.gv.storeOnStorage('ufavlist', this.gv.ufavlist);
    //                     this.gv.loadedfav = true;
    //                     this.gv.chkchannelvisit();

    //                     if(refresh) setTimeout(_=>{refresh.target.complete()},150);
    //                     }
    //                   }
    //                 })
    //               });
    //             }
    //           })
    //         })
    //         //this.gv.loadingboard = false;
    //       }
    //       else {
    //         this.gv.loadingboard = false;
    //       }
    //       //this.gv.ufavlist = temp;
    //       this.gv.loadedfav = true;

    //       // console.log(this.gv.ufavlist);
    //       this.getdata();
    //       this.gv.getHotLive(this.gv.ufavlist);
          
    //     // }, refresh ? 151 : 0)
    //   })
    // }
    // else {
    //   firebase.database().ref('/app/setting/aus/' + this.gv.loc + '/' + this.gv.lan + '/fav').once('value').then(fav => {
    //     let temp = [];
    //     let templist = [];
    //     let boardtemp = [];
    //     let boardlisttemp = [];
    //     let count = 0;
    //     this.gv.loadingboard = true;
    //     // if (refresh) setTimeout(_ => { refresh.target.complete() }, 100);
    //     if (fav.val()) {
    //       if (this.gv.needfillfav && this.gv.uid) {
    //         firebase.database().ref('/userData/' + this.gv.uid + '/favlist').set(fav.val()).then(_ => {
    //           this.gv.needfillfav = false;
    //           //fcm필요
    //           Object.keys(fav.val()).forEach(fitem => {
    //             let f = fav.val()[fitem];
    //             //if(f.alarm)
    //             this.authData.setnoti('sub', f.chid);
    //           })
    //         })
    //       }
    //       else {
    //         this.gv.setfavinlocal(fav.val());
    //         let favindex = 0;
    //         Object.keys(fav.val()).forEach(fitem => {
    //           let f = fav.val()[fitem];
    //           f.favindex = favindex;
    //           favindex++;
    //           firebase.database().ref('/category/' + f.chid).once('value').then(chval => {
    //             let favdata = chval.val();
    //             if(!favdata)
    //               temp.push({chid:f.chid,alarm:false,title:'삭제된채널',customtitle:f.customtitle})
    //             else
    //               {
    //               temp.push({
    //               chid: f.chid,
    //               alarm: f.alarm,
    //               favindex: f.favindex,
    //               loc: f.loc,
    //               isChecked: f.isChecked,
    //               customtitle: f.customtitle,
    //               title: favdata.name,
    //               img: favdata.imagethumb?favdata.imagethumb[0].url:null,
    //               isMine: favdata.userId == this.gv.uid,
    //               lastposting: favdata.recent ? favdata.recent : ''
    //             });
    //             if (favdata.recent)
    //               Object.keys(favdata.recent).forEach(rkey => {
    //                 templist.push({ $key: favdata.recent[rkey].itemid, rcreatedDate: favdata.recent[rkey].createdDate })
    //               })
    //               }

    //             count++;
    //             if (count == Object.keys(fav.val()).length) {
    //               boardtemp = this.orderby.transform(templist, 'rcreatedDate', 'desc').slice(0, 36);
    //               let tempcount = 0;
    //               //this.gv.loadingboard = true;
    //               let boardlisttemp = [];

    //               boardtemp.map(data => {
    //                 this.fs.collection('post').doc(data.$key).get().subscribe(rst=>{
    //                 //firebase.database().ref('/list/' + data.$key).once('value').then(rst => {
    //                   tempcount++;
    //                   if (rst.data())
    //                     boardlisttemp.push({ $key: data.$key, rcreatedDate: data.rcreatedDate, data: rst.data() })
    //                   if (tempcount == boardtemp.length) {
    //                     this.gv.boardlist = this.orderby.transform(boardlisttemp, 'rcreatedDate', 'desc').slice(0, 30)
    //                     this.gv.storeOnStorage('listdata', this.gv.boardlist);
    //                     this.gv.boardlistpage = Math.ceil(this.gv.boardlist.length / 6)
    //                     this.gv.loadingboard = false;

    //                     this.gv.ufavlist = this.orderby.transform(temp, 'favindex');
    //                     this.gv.storeOnStorage('ufavlist', this.gv.ufavlist);
    //                     this.gv.loadedfav = true;
    //                     this.gv.chkchannelvisit();

    //                     if(refresh) setTimeout(_=>{refresh.target.complete()},150);
    //                   }
    //                 })
    //               });
    //             }
    //           })
    //         })
    //         //this.gv.ufavlist = temp;
    //       }
    //     }
    //     else {
    //       this.gv.loadingboard = false;
    //     }
    //     this.gv.loadedfav = true;
    //     this.getdata();
    //     this.gv.getHotLive(this.gv.ufavlist);
    //   });
    // }

    setTimeout(_=>{
      if(this.gv.loadingboard) {
        this.presentToast('인터넷 연결이 불안정 합니다.');
        if(refresh) setTimeout(_=>{refresh.target.complete()});
      }
    },15000);
  }

  setdefault() {
    // this.gv.needfillfav = true;
    if (this.gv.uid) this.gv.needfillfav = true;
    this.refreshdata();
  }

  // ------------------------------ interval func press and pressup func in fav item
  // @ViewChildren('titip') titip: QueryList<any>;
  @ViewChildren('titip') titip;
  public progress: number = 0;

  // Interval function
  protected interval1: any;
  protected interval2: any;


  clearScrolling() {
    if (this.interval1) clearInterval(this.interval1); this.interval1 = '';
    if (this.interval2) clearInterval(this.interval2); this.interval2 = '';
    this.editable = false;
    if (this.favtoast) this.favtoast.dismiss();
    if (this.gv.ufavlist) {
      this.gv.ufavlist.forEach(fav => {
        fav.titeditmode = false;
        this.titeditmode_total = false;
        fav.intervalTit = 0;
        fav.intervalThumb = 0;
      });
    }
  }

  titeditbool() { // titeditmode 가 하나라도 true 일때 routerLink에 false를 전달하기 위함 
    let titeditbool = false;
    this.gv.ufavlist.forEach(fav => {
      if (fav.titeditmode == true) titeditbool = true;
    });
    return titeditbool;
  }


  // ------------------------------ press and pressup func in fav item 

  chtitclicked(item, titip?) { // 채널 이름 (click) editable 상태 일때.
    this.editable = false;
    if (this.favtoast) this.favtoast.dismiss();
    this.gv.ufavlist.forEach(fav => {
      fav.titeditmode = false;
    })
    item.titeditmode = true;
    this.titeditmode_total = true;
    setTimeout(_ => {
      titip.setFocus(); // 디바이스에서 작동 안됨 ------------------------------- !!!!!
    }, 50);
    let customname;
    this.translate.get('Name your Channel').subscribe(res => { customname = res });
    this.ufavlistToast(customname, item, titip);
  }
  chtitpressed(item, titip?) { // 채널 이름 (press)
    const self = this;
    self.progress = 0;
    this.interval1 = '';
    this.interval1 = setInterval(_ => {
      self.progress = self.progress + 1;
      item.intervalTit = self.progress;

      this.editable = false;
      if (item.intervalTit == 10) {
        if (this.favtoast) this.favtoast.dismiss();
        this.gv.ufavlist.forEach(fav => {
          fav.titeditmode = false;
        })
        item.titeditmode = true;
        this.titeditmode_total = true;
        setTimeout(_ => {
          item.intervalTit = 0;
          titip.setFocus(); // 디바이스에서 작동 안됨 
        }, 50);
        let customname;
        this.translate.get('Name your Channel').subscribe(res => { customname = res });
        this.ufavlistToast(customname, item, titip);
        clearInterval(this.interval1);
      }
    }, 50);
  }
  chtitpressup(item, intervalnum?, titip?) { // 채널 이름 (pressup)
    if (this.interval1) clearInterval(this.interval1);
    setTimeout(_ => {
      item.intervalTit = 0;
    }, 50);
  }

  chthumbpressed(item) { // 채널 이름 (press)
    console.log(item);
    const self = this;
    self.progress = 0;
    if (this.interval2 == '' || this.interval2 == undefined) {
      this.interval2 = setInterval(_ => {
        self.progress = self.progress + 1;
        item.intervalThumb = self.progress;
        if (item.intervalThumb == 10) {
          if (this.favtoast) this.favtoast.dismiss();
          this.editable = true;
          this.gv.ufavlist.forEach(fav => {
            fav.titeditmode = false;
          })
          this.titeditmode_total = false;
          setTimeout(_ => {
            item.intervalThumb = 0;
          }, 50);
          clearInterval(this.interval2);
          this.ufavlistToast();
        }
      }, 50);
    }
  }

  chthumbpressup(item, intervalnum?) { // 채널 이름 (pressup)
    if (this.interval2) clearInterval(this.interval2);
    setTimeout(_ => {
      item.intervalThumb = 0;
    }, 50);
  }

  // imgclicked($event) { // 채널 썸네일 기본 이벤트 막기 (img에 pointer-events: none도 적용)
  //   $event.preventDefault();
  // }

  // ------------------------------ fav item func

  setcustomtit(item, itemtitle, val) { // customtitle 적용 (input 에 enter 할때, toast 에서 확인 버튼 누를 때)
    // $event.preventDefault();
    if (this.favtoast) this.favtoast.dismiss();
    if (val != itemtitle) {
      for (let i = 0; i < this.gv.ufavlist.length; i++) {
        if (this.gv.ufavlist[i].chid == item.chid) {
          this.gv.ufavlist[i].customtitle = val;
          // console.log(this.gv.ufavlist[i]);
        }
      }
    }
    item.titeditmode = false;
    this.titeditmode_total = false;
    this.editable = true; // 이름 변경 후 다시 순서 변경 on
    this.ufavlistToast();
  }

  async ufavlistToast(message?: string, item?, titip?) { // 채널 순서 변경, 이름 변경 Toast
    // if(toast) toast.dismiss();
    let changenameorder, save, done;
    this.translate.get('Change Name or Oder').subscribe(res => { changenameorder = res });
    this.translate.get('Save').subscribe(res => { save = res });
    this.translate.get('Finish').subscribe(res => { done = res });
    this.favtoast = await this.toastCtrl.create({
      message: (message ? message : changenameorder),
      position: 'top',
      cssClass: 'favlisteditable',
      buttons: [
        {
          side: 'end',
          text: (item ? save : done),
          handler: () => {
            if (item) { // item이 있을때 = 이름 변경
              this.setcustomtit(item, item.title, titip.value);
            } else { // item이 없을때 = 순서 변경
              this.editable = false;
              this.interval2 = ''; // 순서 변경 토글용 interval을 초기화 
            }
            let favdata = [];
            this.gv.ufavlist.forEach(fav => {
              favdata.push({
                chid: fav.chid, isChecked: fav.isChecked ? fav.isChecked : null,
                alarm: fav.alarm ? fav.alarm : null, loc: fav.loc ? fav.loc : null,
                customtitle: fav.customtitle ? fav.customtitle : null
              })
            })
            if (this.gv.uid) {
              this.gv.norefresh = true;
              this.afDB.database.ref('/userData/' + this.gv.uid + '/favlist').set(favdata);
            }
            else { }
          }
        }
      ]
    });
    this.favtoast.present();
  }

  /* 
  // 채널 길게 누를때 action sheet 띄워서 편집 하는 버전 

  async editChannSheet(item, titip){
    const actionsheet = await this.actionSheetController.create({
      header: '장소 채널',
      buttons: [{
        text: '위치 변경'
      }, {
        text: '이름 편집',
        role: 'editname',
        // icon: 'trash',
        handler: () => {
          console.log(item);
          item.titeditmode = true;
          setTimeout(_=>{
            titip.setFocus();
          },50);
        }
      }]
    });
    return await actionsheet.present();
  }
  */

  // ------------------------------ CDK drag drop 

  sortEnter(event: CdkDragDrop<string[]>) {
    //console.log("--------------------sortEnter start");
    //console.log(event);
    //console.log("--------------------sortEnter end");
  }
  sortDrop(event: CdkDragDrop<string[]>, ufavlist?) {
    //console.log("sortDrop()");
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      // console.log(event.container.data);
      // console.log(event.previousIndex);
      // console.log(event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    if (this.interval1) clearInterval(this.interval1);
    if (this.interval2) clearInterval(this.interval2);
    // this.editable = false;

    ufavlist.forEach(fav => {
      fav.intervalTit = 0;
      fav.intervalThumb = 0;
      //console.log(fav);
    });

  }





  // ---------------------


  addChannAction($event) {
    // this.gotochannlist(0, 723);
    this.gotochannlist(0, this.totalchannel.nativeElement.offsetTop - 28);
    setTimeout(_ => {
      this.channguide = true;
    }, 500);
  }



  contentScrolling($event) {
    let scrolledval = $event.detail.scrollTop;
    // console.log($event.detail.scrollTop);
    // console.log(scrolltarget);
    let target = this.totalchannel.nativeElement.offsetTop;

    if (scrolledval >= (target - 50)) { // 스크롤 된 값이 target값 조금 전보다 크거나 같을때
      this.fixedheader = true; // 일단 헤더를 active 하기전 fixed 시킴 (화면 밖에서)
    } else {
      this.fixedheader = false;
    }
  }



  // -------------------------- 200302 

  prevslide(slide) {
    slide.slidePrev();
  }
  nextslide(slide) {
    slide.slideNext();
  }

  
  // ---------------------------

  chopmsg(item){
    switch (item) {
      case ('privatechann') : this.presentToast('비공개 채널 입니다.'); break;
      case ('anonymouse') : this.presentToast('익명 댓글이 적용된 채널 입니다.'); break;
      case ('private') : this.presentToast('비공개 댓글이 적용된 채널 입니다.'); break;
    }
  }

}
